'use client'

import { useSearchParams } from '@/lib/hooks'
import { cn } from '@/lib/utils'

interface CartProductsLayoutProps
  extends React.ComponentPropsWithoutRef<'div'> {}

export const CartProductsLayout = ({
  children,
  className,
  ...restProps
}: CartProductsLayoutProps) => {
  const { showMobileCart } = useSearchParams()

  return (
    <div
      key="cart-products-list"
      className={cn(
        'flex w-full shrink-0 flex-col overflow-hidden transition-transform duration-5000 @container/products lg:w-[var(--cart-products-layout-width)]',
        {
          hidden: showMobileCart,
        },
        className,
      )}
      {...restProps}
    >
      {children}
    </div>
  )
}
